"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REF_ATTRIBUTE_NAME = "ref";
exports.UNWRAP_ATTRIBUTE_NAME = "unwrap";
exports.SLOT_ATTRIBUTE_NAME = "slot";
//# sourceMappingURL=iattributes.js.map